import script from "./DotsLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./DotsLoading.vue?vue&type=script&setup=true&lang=js"

import "./DotsLoading.vue?vue&type=style&index=0&id=dc8ad520&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc8ad520"]])

export default __exports__